import { createRouter, createWebHistory } from "vue-router";
// import DasboardView from "@/views/DashboardView.vue";
import ManageVehicles from "@/views/planning/vehicles/ManageVehicles.vue";
import EditVehicle from "@/views/planning/vehicles/EditVehicle.vue";
import ManageClients from "@/views/planning/clients/ManageClients.vue";
import EditClient from "@/views/planning/clients/EditClient.vue";
import ManageAddresses from "@/views/planning/addresses/ManageAddresses.vue";
import CreateEditAddress from "@/views/planning/addresses/CreateEditAddress.vue";

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import DefaultMobileLayout from "@/layouts/DefaultMobileLayout.vue";

import ManageUsers from "@/views/planning/users/ManageUsers.vue";
import EditUser from "@/views/planning/users/EditUser.vue";
import ManageTravels from "@/views/planning/travels/ManageTravels.vue";
import TravelView from "@/views/planning/travels/TravelView.vue";
import ManageTrips from "@/views/planning/trips/ManageTrips.vue";
import TripCreate from "@/views/planning/trips/TripCreate.vue";
import TripView from "@/views/planning/trips/TripView.vue";
import TripEdit from "@/views/planning/trips/TripEdit.vue";
import ManageUnregisteredTrips from "@/views/planning/unregisteredTrips/ManageUnregisteredTrips.vue";
import UnregisteredTripEdit from "@/views/planning/unregisteredTrips/UnregisteredTripEdit.vue";
import LoginView from "@/views/auth/LoginView.vue";
import DocumentationView from "@/views/support/DocumentationView.vue";

/*
  Components for mobile
*/
import DriverTravels from "@/views/driving/travels/DriverTravels.vue";
import DriverTravelView from "@/views/driving/travels/DriverTravelView.vue";
import DriverStatisticsView from "@/views/driving/statistics/DriverStatisticsView.vue";
import DriverProfileView from "@/views/driving/profile/DriverProfileView.vue";

import { useAuthStore } from "@/stores/auth";

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresGuest: true },
  },
  {
    path: "/",
    component: DefaultLayout,
    meta: { requiresAuth: true }, // Add this to protect all child routes
    children: [
      // {
      //   path: "/dashboard",
      //   component: DasboardView,
      //   meta: { title: "Pagrindinis" },
      // },
      {
        path: "vehicles",
        component: ManageVehicles,
        meta: { title: "Transporto priemonės" },
      },
      {
        path: "vehicles/new",
        component: EditVehicle,
        meta: { title: "Transporto priemonės" },
      },
      {
        path: "vehicles/:id/edit",
        component: EditVehicle,
        meta: { title: "Transporto priemonės" },
      },
      {
        path: "clients",
        component: ManageClients,
        meta: { title: "Pavėžėjimo paslaugų gavėjai" },
      },
      {
        path: "clients/new",
        component: EditClient,
        meta: { title: "Pavėžėjimo paslaugų gavėjai" },
      },
      {
        path: "clients/:id/edit",
        component: EditClient,
        meta: { title: "Pavėžėjimo paslaugų gavėjai" },
      },
      {
        path: "addresses",
        component: ManageAddresses,
        meta: { title: "Adresai" },
      },
      {
        path: "addresses/new",
        component: CreateEditAddress,
        meta: { title: "Adresai" },
      },
      {
        path: "addresses/:id/edit",
        component: CreateEditAddress,
        meta: { title: "Adresai" },
      },
      {
        path: "users",
        component: ManageUsers,
        meta: { title: "Vartotojai" },
      },
      {
        path: "users/:id/edit",
        component: EditUser,
        meta: { title: "Vartotojai" },
      },
      {
        path: "travels",
        component: ManageTravels,
        meta: { title: "Kelionės" },
      },
      {
        path: "travels/:id/view",
        component: TravelView,
        meta: { title: "Kelionės" },
      },
      {
        path: "trips",
        component: ManageTrips,
        meta: { title: "Pavėžėjimų užsakymai" },
      },
      {
        path: "trips/create/:tripId?",
        component: TripCreate,
        meta: { title: "Registruoti pavėžėjimą" },
      },
      {
        path: "trips/:id/view",
        name: "TripView",
        component: TripView,
        meta: { title: "Peržiūrėti pavėžėjimą" },
      },
      {
        path: "trips/:id/edit",
        name: "TripEdit",
        component: TripEdit,
        meta: { title: "Redaguoti pavėžėjimą" },
      },
      {
        path: "unregistered-trips",
        name: "UnregisteredTrips",
        component: ManageUnregisteredTrips,
        meta: { title: "Neregistruoti pavėžėjimai" },
      },
      {
        path: "unregistered-trips/create",
        name: "UnregisteredTripsCreate",
        component: UnregisteredTripEdit,
        meta: { title: "Įtraukti neregistruotą pavėžėjimą" },
      },
      {
        path: "unregistered-trips/:id/edit",
        name: "UnregisteredTripsEdit",
        component: UnregisteredTripEdit,
        meta: { title: "Redaguoti neregistruotą pavėžėjimą" },
      },
      {
        path: "support/documentation",
        component: DocumentationView,
        meta: { title: "Dokumentacija" },
      },
    ],
  },
  {
    path: "/driving",
    redirect: "/driving/travels",
    component: DefaultMobileLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "travels",
        name: "DriverTravels",
        component: DriverTravels,
        meta: { title: "Kelionės" },
      },
      {
        path: "travels/:id/",
        name: "DriverTravelView",
        component: DriverTravelView,
        meta: { title: "Kelionė" },
      },
      {
        path: "statistics",
        name: "DriverStatisticsView",
        component: DriverStatisticsView,
        meta: { title: "Statistika" },
      },
      {
        path: "profile",
        name: "DriverProfileView",
        component: DriverProfileView,
        meta: { title: "Vairuotojas" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isAuthenticated;

  // If route requires auth and user is not authenticated
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: "login" });
      return;
    }

    // Root path has no view of its own. Drivers get the mobile driving
    // interface only when they're actually on a mobile device (they may
    // also use the desktop planner view); everyone else lands on planner.
    if (to.path === "/") {
      if (!authStore.user) {
        try {
          await authStore.fetchUser();
        } catch {
          next({ name: "login" });
          return;
        }
      }

      const isMobileDevice =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        );
      const isSmallScreen = window.innerWidth <= 768;
      const isMobile = isMobileDevice || isSmallScreen;

      const isDriver = authStore.user?.role === "driver";
      next(isDriver && isMobile ? "/driving" : "/travels");
      return;
    }
  }

  // If route requires guest and user is authenticated (like login page)
  if (to.matched.some((record) => record.meta.requiresGuest)) {
    if (isAuthenticated) {
      next({ path: "/travels" });
      return;
    }
  }

  next();
});

export default router;
